module.exports = __webpack_public_path__ + "static/images/coupon-img02.d0bd65b.png";